import { useState } from "react";

import {
  EnrichedProfileState,
  EnrichmentInputsState,
  EnrichmentMessage,
} from "@/types";

const EMPTY_ENRICHED_PROFILE: EnrichedProfileState = {
  executiveSummary: null,
  professionalSummary: null,
  workExperiences: null,
  educations: null,
  certifications: null,
  skills: null,
};

export const useEnrichmentInputs = (): EnrichmentInputsState => {
  // Default to empty Set; EnrichmentInputs hydrates with all available IDs once
  // the calls/outreaches queries resolve. Empty after hydration means "include 0".
  const [selectedStafferCallIds, setSelectedStafferCallIds] = useState<
    Set<string>
  >(() => new Set());
  const [selectedStevieCallIds, setSelectedStevieCallIds] = useState<
    Set<string>
  >(() => new Set());
  const [referenceCallTranscript, setReferenceCallTranscript] = useState<
    string | null
  >(null);
  const [additionalContext, setAdditionalContext] = useState<string | null>(
    null,
  );
  const [prompt, setPrompt] = useState("");
  const [messages, setMessages] = useState<EnrichmentMessage[]>([]);
  const [enrichedProfile, setEnrichedProfile] = useState<EnrichedProfileState>(
    EMPTY_ENRICHED_PROFILE,
  );
  const [isEnriching, setIsEnriching] = useState(false);

  return {
    selectedStafferCallIds,
    setSelectedStafferCallIds,
    selectedStevieCallIds,
    setSelectedStevieCallIds,
    referenceCallTranscript,
    setReferenceCallTranscript,
    additionalContext,
    setAdditionalContext,
    prompt,
    setPrompt,
    messages,
    setMessages,
    enrichedProfile,
    setEnrichedProfile,
    isEnriching,
    setIsEnriching,
  };
};
